module.exports = __webpack_public_path__ + "img/v08.5178ef25.jpg";